module.exports = __webpack_public_path__ + "static/media/img_howto_phone_illust2_1@3x.46b4bb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_howto_phone_illust2_1@3x.png
// module id = 1093
// module chunks = 0